import { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

import { buscarLocalidadesAtendidasByPontoMototaxi } from '../servicos/listagemServico';
import { excluirLocalidadeAtendida } from '../servicos/exclusaoServico';

function ListarLocalidadesAtendidas() {
  const [localidadesAtendidas, setLocalidadesAtendidas] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Entrou no useEffect do ListarLocalidadesAtendidas.js....');

    const carregarLocalidadesAtendidas = async () => {
      try {
        const cookies = Cookies.get();
        const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

        if (!dadosCookies || !dadosCookies.dadosPontoMototaxi?.id) {
          alert("Erro: dados do ponto não encontrados.");
          return;
        }

        console.log('Buscando localidades atendidas...');
        const resposta = await buscarLocalidadesAtendidasByPontoMototaxi(dadosCookies);

        console.log('Localidades recebidas: ', resposta.localidadesAtendidas);
        setLocalidadesAtendidas(resposta.localidadesAtendidas || []);
      } catch (erro) {
        console.error("Erro ao buscar as localidades:", erro);
        alert("Erro ao buscar as localidades.");
      }
    };

    carregarLocalidadesAtendidas();
  }, []);

  const handleExcluir = async (id) => {
    const confirmado = window.confirm('Tem certeza que deseja excluir esta localidade?');
    if (!confirmado) return;

    try {
      await excluirLocalidadeAtendida(id);
      setLocalidadesAtendidas((prev) => prev.filter((localidade) => localidade.id !== id));
    } catch (error) {
      alert('Erro ao excluir a localidade: ' + error.message);
    }
  };

  const handleEditar = (localidade) => {
    navigate('/cadastrar-localidades-atendidas', { state: { localidade } });
  };

  // Função para formatar valores como moeda
  const formatarMoeda = (valor) => {
    if (valor == null) return '-';
    return Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  return (
    <div className="listar-localidades-atendidas">
      <div className="card p-4 shadow-sm" style={{ width: '100%', maxWidth: '800px', margin: '2rem auto' }}>
        <div className="card-body">
          <h3 className="text-center mb-4">Localidades Atendidas</h3>

          {localidadesAtendidas.length === 0 ? (
            <p className="text-center">Nenhuma localidade encontrada.</p>
          ) : (
            <div className="lista-localidades">
              {localidadesAtendidas.map((localidade) => (
                <div key={localidade.id} className="mb-4 p-3 border rounded">
                  <p><strong>Nome da localidade:</strong> {localidade.nome}</p>
                  <p><strong>Cidade:</strong> {localidade.cidade}</p>
                  <p><strong>Estado:</strong> {localidade.uf}</p>
                  <p><strong>Valor diurno (06h às 23h):</strong> {formatarMoeda(localidade.valor_6_as_23)}</p>
                  <p><strong>Valor noturno (23h às 06h):</strong> {formatarMoeda(localidade.valor_23_as_6)}</p>

                  <div className="d-flex gap-2 mt-2 " >

                    {/* <button 
                      className="btn btn-primary btn-sm"
                      onClick={() => handleEditar(localidade)}
                    >
                      Editar
                    </button> */}

                    <button 
                      className="btn btn-danger btn-sm"
                      onClick={() => handleExcluir(localidade.id)}
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              ))}

                <button 
                  className="btn btn-primary btn-sm"
                  onClick={() => navigate("/cadastrar-localidades-atendidas")}
                >
                  Cadastrar Localidade
                </button>

            </div>
            
          )}
        </div>
      </div>
    </div>
  );
}

export default ListarLocalidadesAtendidas;
